import { combineReducers } from 'redux';

import * as actions from '../actions';
import { getCompanyById } from './companies';
import { getUserById } from './users';
import { getBusinessInformationById } from './businessInformations';
import { getQuestionnaireById } from './questionnaires';

function byId(type) {
  return (state = {}, action) => {
    switch (action.type) {
      case actions.REQUEST_ORDER_SUCCESS:
        return action.listType === type
          ? Object.assign({}, state, action.data.response.entities.orders)
          : Object.assign({}, state);
      case actions.REQUEST_ORDER_ERROR:
        return action.listType === type
          ? {}
          : Object.assign({}, state);
      case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      case actions.PLACE_ORDER_FOREIGN_SUCCESS:
        return type === 'pending'
          ? Object.assign({}, state, action.data.response.entities.orders)
          : Object.assign({}, state);
      default:
        return state;
    }
  };
}

function ids(type) {
  return (state = [], action) => {
    switch (action.type) {
      case actions.REQUEST_ORDER_SUCCESS:
        return action.listType === type
          ? action.data.response.result
          : Object.assign([], state);
      case actions.REQUEST_ORDER_ERROR:
        return action.listType === type
          ? []
          : Object.assign([], state);
      case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      case actions.PLACE_ORDER_FOREIGN_SUCCESS:
        return type === 'pending'
          ? Object.assign([], state, action.data.response.result)
          : Object.assign([], state);
      default:
        return state;
    }
  };
}

function total(type) {
  return (state = 0, action) => {
    switch (action.type) {
      case actions.REQUEST_ORDER_SUCCESS:
        return action.listType === type
          ? action.data.total
          : state;
      case actions.REQUEST_ORDER_ERROR:
        return action.listType === type
          ? 0
          : state;
      default:
        return state;
    }
  };
}

function loading(type) {
  return (state = false, action) => {
    switch (action.type) {
      case actions.REQUEST_ORDER_START:
        return action.listType === type ? true : state;
      case actions.REQUEST_ORDER_SUCCESS:
      case actions.REQUEST_ORDER_ERROR:
        return action.listType === type ? false : state;
      case actions.PLACE_ORDER_NATIONAL_START:
      case actions.PLACE_ORDER_FOREIGN_START:
        return type === 'pending';
      case actions.PLACE_ORDER_NATIONAL_ERROR:
      case actions.PLACE_ORDER_FOREIGN_ERROR:
      case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      case actions.PLACE_ORDER_FOREIGN_SUCCESS:
        return type !== 'pending';
      case actions.REOPEN_ORDER_START:
      case actions.COMPLETE_ORDER_START:
        return true;
      case actions.REOPEN_ORDER_SUCCESS:
      case actions.REOPEN_ORDER_ERROR:
      case actions.COMPLETE_ORDER_SUCCESS:
      case actions.COMPLETE_ORDER_ERROR:
        return false;
      default:
        return state;
    }
  };
}

function error(type) {
  return (state = null, action) => {
    switch (action.type) {
      case actions.REQUEST_ORDER_START:
      case actions.REQUEST_ORDER_SUCCESS:
        return action.listType === type ? null : state;
      case actions.REQUEST_ORDER_ERROR:
        return action.listType === type
          ? (action.err && action.err.message) || process.env.ERR_GENERIC
          : state;
      case actions.PLACE_ORDER_NATIONAL_START:
      case actions.PLACE_ORDER_FOREIGN_START:
      case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      case actions.PLACE_ORDER_FOREIGN_SUCCESS:
        return type === 'pending'
          ? null
          : state;
      case actions.PLACE_ORDER_ERROR:
      case actions.PLACE_ORDER_FOREIGN_ERROR:
        return type === 'pending'
          ? (action.err && action.err.message) || process.env.ERR_GENERIC
          : state;
      default:
        return state;
    }
  };
}

const pending = combineReducers({
  loading: loading('pending'),
  byId: byId('pending'),
  ids: ids('pending'),
  total: total('pending'),
  error: error('pending'),
});

const archived = combineReducers({
  loading: loading('archived'),
  byId: byId('archived'),
  ids: ids('archived'),
  total: total('archived'),
  error: error('archived'),
});

const edited = combineReducers({
  loading: loading('edited'),
  byId: byId('edited'),
  ids: ids('edited'),
  total: total('edited'),
  error: error('edited'),
});

const orders = combineReducers({
  pending,
  archived,
  edited,
});

export default orders;

export const getOrders = (state, type) => (state.orders[type].ids || [])
  .map(id => Object.assign({}, state.orders[type].byId[id], {
    businessInformation: getBusinessInformationById(state,
      state.orders[type].byId[id].businessInformation),
    questionnaires: (state.orders[type].byId[id].questionnaires || [])
      .map(questionnaireId => getQuestionnaireById(state, questionnaireId)),
    buyer: getUserById(state, state.orders[type].byId[id].buyer),
    company: getCompanyById(state, state.orders[type].byId[id].company),
  }));

export const getLoading = (state, type) => state.orders[type].loading;
